import * as React from 'react'

import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'

type Props = {
  setZipCodeValid: (value: boolean) => void
  formFieldName: string
}

export function ZipCode(props: Props) {
  const { setZipCodeValid, formFieldName } = props
  const { value, errorText, status } = useData()
  const {
    removeZipCode,
    handZipCodeInput,
    validateZipCodes,
    handleZipBlur,
    handleChange,
    handleOnClick,
  } = useHandlers({ setZipCodeValid, formFieldName })
  const { t } = useTranslation()
  const chips = document.getElementById('chips')

  if (chips) {
    chips.scrollTop = chips.scrollHeight
  }

  return (
    <Stack position="relative" pb={2}>
      <Autocomplete
        value={value}
        options={[]}
        open={false}
        onKeyDown={handZipCodeInput}
        onInput={validateZipCodes}
        onBlurCapture={handleZipBlur}
        onChange={handleChange}
        clearOnBlur={!errorText}
        renderTags={(value) => (
          <Stack
            direction="row"
            gap={1}
            flexWrap="wrap"
            maxHeight={170}
            overflow="auto"
            id="chips"
          >
            {value.map((option, idx) => (
              <Chip
                key={`ZipCode_${idx}`}
                color="secondary"
                label={option}
                onDelete={() => removeZipCode(idx)}
              />
            ))}
          </Stack>
        )}
        freeSolo
        multiple
        renderInput={(params) => (
          <TextField
            {...params}
            onClick={handleOnClick}
            placeholder={t('typeCodeAndEnter')}
            size="medium"
            label={`${t('postalCode')} *`}
            error={!!errorText}
            fullWidth
            InputProps={{
              ...params.InputProps,
              sx: { width: 'auto', minWidth: '60px' },
            }}
          ></TextField>
        )}
        size="medium"
      ></Autocomplete>
      <Box ml={1.4} bottom={0} width={500}>
        <FormHelperText error>{status?.message ?? errorText}</FormHelperText>
      </Box>
    </Stack>
  )
}
